export default "__VITE_ASSET__gDe6m2mm__"